<template>
  <v-container fluid :class="currentEvent == null ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null">
      <v-col>
        <Loading />
      </v-col>
    </v-row>

    <v-row align="center" v-else>
      <!--Start: Tabs -->
      <v-col cols="12">
        <v-card class="pl-12 py-5 pr-10" outlined>
          <v-row no-gutters>
            <v-col cols="12">
              <BackButton text="EventConnect" @click="handleExitMultiConnect" />
            </v-col>

            <v-col cols="12" v-if="isEditMode">
              <div class="text-left mt-2 pl-3">
                <v-chip
                  label
                  :color="currentEvent.getStatusColor()"
                  :textColor="currentEvent.getStatusTextColor()"
                  class="font-weight-medium"
                  dark
                  small
                  >{{ currentEvent.getStatus() }}</v-chip
                >
              </div>
            </v-col>
          </v-row>

          <v-card-title
            :class="[
              'text-capitalize justify-space-between d-flex',
              { 'text-h6': isEditMode },
            ]"
          >
            <template v-if="isEditMode">{{ currentEvent.name }}</template>
            <template v-else-if="currentEvent.eventCategory==='travel'">Create new Travel Itinarery </template>
            <template v-else>Create new EventConnect link</template>

            <template
              v-if="
                currentEvent.dynamicLink != '' &&
                currentEvent.linkPrivacy != 'Private' &&
                isEditMode
              "
            >
              <v-menu
                :close-on-content-click="false"
                max-width="250"
                :offset-y="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-body-1 mt-4 share-mc d-inline-block primary--text"
                    @click="showShareMultiConnectLinkMenu = true"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-link-variant</v-icon>
                    Share link &nbsp;
                  </div>
                </template>
                <v-card>
                  <v-tabs v-model="shareMenuTab">
                    <v-tab>Link</v-tab>
                    <v-tab>QR code</v-tab>
                  </v-tabs>
                  <v-divider></v-divider>
                  <v-tabs-items v-model="shareMenuTab">
                    <v-tab-item eager>
                      <v-list class="px-2">
                        <v-list-item class="py-0" @click="shareViaEmail">
                          <v-list-item-icon class="mr-2">
                            <v-icon small>mdi-email-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Share via email</v-list-item-subtitle
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="py-0" @click="copyToClipboard">
                          <v-list-item-icon class="mr-2">
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Copy EventConnect link</v-list-item-subtitle
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-tab-item>
                    <v-tab-item eager>
                      <div
                        class="d-flex justify-center align-center flex-column py-4"
                      >
                        <div class="text-body-2 text-left px-4 grey--text">
                          Here is your unique EventConnect QR code that will
                          direct people to your EventConnect link when scanned.
                        </div>
                        <QRCode :link="eventLink(true)" />
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-menu>
            </template>
          </v-card-title>

          <v-divider v-if="!isEditMode"></v-divider>

          <v-card-text>
            <!---Start: Show tabs in Edit Mode--->
            <template v-if="isEditMode">
              <v-tabs
                v-model="currentEvent.currentTab"
                active-class="primary--text"
              >
                <template v-for="(tab, index) in tabs">
                  <v-tab
                    v-if="
                      (!isEditMode &&
                        (tab.title == 'Link Details' ||
                          tab.title == 'Sponsors')) ||
                      isEditMode
                    "
                    :key="`tab` + index"
                    :class="
                      tab.index < currentEvent.wizardProgress
                        ? 'secodnary--text'
                        : ''
                    "
                    :disabled="disableTab(tab)"
                  >
                    {{ tab.title }}
                  </v-tab></template
                >
              </v-tabs>
              <v-divider></v-divider>
              <v-tabs-items v-model="currentEvent.currentTab">
                <v-tab-item>
                  <AddEditLinkDetails
                    ref="addEditLinkDetails"
                    :isEditMode="isEditMode"
                    :isSuperUserDashboard="
                      queryPrivilege && queryPrivilege == 'superUser'
                    "
                    :displayImageURLError="displayImageURLError"
                  />
                </v-tab-item>
                <v-tab-item>
                  <AddEditSponsors :isEditingMCEvent="isEditMode" />
                </v-tab-item>
                <v-tab-item>
                  <EventProgramTable />
                </v-tab-item>
                <v-tab-item>
                  <AddEditLinkInvitation
                    @next="currentEvent.currentTab = 4"
                    :isEditMode="isEditMode"
                  />
                </v-tab-item>
<!--                <v-tab-item>
                  <AddEditEventPromotion ref="eventPromotion" />
                </v-tab-item>-->
                <v-tab-item>
                  <LinkRegistrants />
                </v-tab-item>
                <v-tab-item>
                  <Analytics />
                </v-tab-item>
              </v-tabs-items>
            </template>
            <!---End: Show tabs in Edit Mode--->

            <!--Start: Stepper in Create Mode--->
            <template v-else>
              <v-stepper v-model="currentStep" alt-labels class="elevation-0">
                <v-stepper-header class="elevation-0">
                  <template v-for="item in currentEvent.stepper">
                    <v-stepper-step
                      @click="handleStepClick(item.step, item.stepName)"
                      :complete="item.step < currentStep"
                      :key="`stepper` + item.step"
                      :class="['text-no-wrap']"
                      :step="item.step"
                      color="primary lighten-1"
                      error-icon="mdi-alert-circle"
                    >
                      <span>{{ item.header }}</span>
                    </v-stepper-step>
                    <v-divider
                      v-if="item.step != currentEvent.stepper.length"
                      :key="`${item.step}Divider`"
                    ></v-divider>
                  </template>
                </v-stepper-header>

                <v-stepper-items>
                  <!-- <v-stepper-content step="1" v-if="!currentEvent.hasSubEvents">
                    <EventFormat ref="step1" />
                  </v-stepper-content>
                  <v-stepper-content step="1">
                    <v-row>
                      <v-col cols="6">
                        <AddEditHostDetails ref="step2" />
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <AddEditEventDetails :isEditMode="false" ref="step3" />
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <UploadImages ref="step4" />
                  </v-stepper-content>
                  <v-stepper-content step="4">
                    <AddEditSponsors :isEditingMCEvent="false" ref="step5" />
                  </v-stepper-content>
                 -->

                  <!---Start: Stepper content--->
                  <template v-for="(item, index) in currentEvent.stepper">
                    <v-stepper-content
                      :key="`${index}StepperContent`"
                      :step="item.step"
                    >
                      <!--Display custom component inside stepper content-->

                      <component
                        :is="item.content"
                        :key="`component` + item.step"
                        v-bind="{ ...item.props }"
                        :ref="`step${index}`"
                        @validatePage="registerValidation"
                      ></component>
                    </v-stepper-content>
                  </template>
                  <!---End: Stepper content---->
                </v-stepper-items>
              </v-stepper>
            </template>
            <!--End: Stepper in Create Mode--->
          </v-card-text>

          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="d-flex justify-start">
                <v-btn
                  width="150"
                  color="grey lighten-4"
                  depressed
                  class="text-body-1 mr-4"
                  large
                  v-if="!isEditMode"
                  @click="handleBack"
                  >{{ backButtonText }}</v-btn
                >
                <v-btn
                  width="150"
                  color="primary"
                  depressed
                  class="text-body-1"
                  @click="handleNext"
                  :disabled="disableSaveButton"
                  large
                  v-if="
                    (isEditMode && currentEvent.currentTab == 0) || !isEditMode
                  "
                  >{{ saveButtonText }}</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

        <MultiConnectLinkDialog
          :showDialog="showDialog"
          @closeDialog="handleCloseDialog"
        />

        <LoadingDialog
          :show="showLoadingDialog"
          title="Creating EventConnect event..."
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "@/components/DatePicker";
import TimePicker from "@/components/TimePicker";
import AddEditLinkDetails from "@/components/MultiConnect/AddEditLinkDetails";
import AddEditLinkInvitation from "@/components/AddEditLinkInvitation";
import AddEditPrizeDraw from "@/components/AddEditPrizeDraw";
import LinkRegistrants from "@/components/LinkRegistrants";
import MultiConnectLinkDialog from "@/components/MultiConnectLinkDialog";
import { mapGetters, mapActions } from "vuex";
import Utility from "@/shared/utility";
import Loading from "@/components/Loading";
import QRCode from "@/components/QRCode";
import Event from "@/models/Event";
import EventTrigger from "@/models/EventTrigger";
import constants from "@/shared/constants";
import AddEditSponsors from "@/components/MultiConnect/AddEditSponsors";
import Post from "@/models/Post";
import LoadingDialog from "@/components/LoadingDialog";
import AddEditEventPromotion from "@/components/MultiConnect/AddEditEventPromotion";
import Attendee from "@/models/Attendee";
import BackButton from "@/components/BackButton.vue";
import EventFormat from "@/components/MultiConnect/Stepper/EventFormat";
import AddEditHostDetails from "@/components/MultiConnect/AddEditHostDetails";
import AddEditEventDetails from "@/components/MultiConnect/AddEditEventDetails";
import UploadImages from "@/components/MultiConnect/UploadImages";
import Analytics from "@/components/MultiConnect/Analytics";
import EventProgramTable from "@/components/MultiConnect/EventProgramTable";
import {onSnapshot} from "firebase/firestore";
import {eventDocRef} from "@/shared/firebase_utils";

let uuid = require("uuid");

export default {
  components: {
    DatePicker,
    TimePicker,
    AddEditLinkDetails,
    AddEditLinkInvitation,
    AddEditPrizeDraw,
    LinkRegistrants,
    MultiConnectLinkDialog,
    Loading,
    QRCode,
    AddEditSponsors,
    LoadingDialog,
    AddEditEventPromotion,
    BackButton,
    EventFormat,
    AddEditHostDetails,
    AddEditEventDetails,
    UploadImages,
    Analytics,
    EventProgramTable,
  },
  computed: {
    ...mapGetters([
      "currentEvent",
      "userProfile",
      "selectedBusinessProfileId",
      "businessProfile",
      "linkedSubEvents",
    ]),
    saveButtonText() {
      if (this.isEditMode) {
        return "Save";
      } else {
        return this.currentStep == this.currentEvent.stepper.length
          ? "Done"
          : "Next";
        // return "Create Multi Connect Event";
      }
    },

    isLastCreatedTab() {
      console.log(
        "this.currentEvent.currentTab: ",
        this.currentEvent.currentTab
      );
      if (this.currentEvent.currentTab == 1) return true;
      else return false;
      // return true;
    },

    disableSaveButton() {
      if (this.businessProfile.plan != "evolve") return true;
      if (this.isAwaitingSave) return true;
      //Validate link-details form
      if (this.currentEvent.currentTab == 0) {
        this.$root.$on("validate", (isValid) => {
          return isValid;
        });
      }

      return false;
    },

    expirationDateTime() {
      return this.currentEvent?.getEventExpirationDateTime();
    },

    currentStep() {
      let currentStepItem = this.currentEvent.stepper.find((step) => {
        return step.stepName == this.currentEvent.currentStep;
      });

      if (currentStepItem) return currentStepItem.step;
      else return 1;
    },

    backButtonText() {
      if (this.currentStep == 1) return "Cancel";
      else return "Back";
    },
  },

  async created() {
    this.eventId = this.$route.params.eventId;

    let queryTab = this.$route.query.tab;

    this.queryPrivilege = this.$route.query.privilege;

    //Set the edit mode based on route
    this.currentRoute = this.$router.currentRoute.name;

    if (this.currentRoute == "editMultiConnect") {
      this.isEditMode = true;
      let multiConenctRoute = {
        name: "editMultiConnect",
        params: { eventId: this.eventId },
      };

      if (this.queryPrivilege && this.queryPrivilege == "superUser")
        multiConenctRoute.query = { privilege: "superUser" };

      this.$router.replace(multiConenctRoute);
    } else {
      let multiConenctRoute = {
        name: "addMultiConnect",
        params: { eventId: this.eventId },
      };
      if (this.queryPrivilege && this.queryPrivilege == "superUser")
        multiConenctRoute.query = { privilege: "superUser" };
      this.$router.replace(multiConenctRoute);
    }

    this.unsubscribeEventsSnapshot = onSnapshot(
          eventDocRef(this.eventId),
          async (documentSnapshot) => {
        //Event exists in firestore
        if (documentSnapshot.data() != undefined) {
          let newEvent = Event.fromFireStore(documentSnapshot);
          // Update the current tab
          if (this.currentEvent != null) {
            newEvent.currentTab = this.currentEvent.currentTab;
          }
          if (newEvent.eventCategory === 'travel') {
            this.isTravelEvent = true;
          }
          await this.setCurrentEvent(newEvent);

          if (this.currentEvent.hasSubEvents) {
            this.stepper =
              constants.MULTI_CONNECT_WIZARD_STEPPER_WITH_SUB_EVENTS;
          } else {
            this.stepper = constants.MULTI_CONNECT_WIZARD_STEPPER;
          }

          if (this.runInitialSetup && this.currentEvent != null) {
            this.runInitialSetup = false;

            if (this.isEditMode) {
              // this.currentEvent.currentTab = 0;
              this.tabs.push({ index: 4, title: "Registrants" });
              this.tabs.push({ index: 5, title: "Analytics" });
              this.eventStatus = this.currentEvent.getStatus();
              this.updatedEventName = this.currentEvent.name;
              if (queryTab == "3") this.currentEvent.currentTab = 3;
              else if (queryTab == "2") this.currentEvent.currentTab = 2;
              else if (queryTab == "1") this.currentEvent.currentTab = 1;
              else if (queryTab == "4") this.currentEvent.currentTab = 4;
              else if (queryTab == "5") this.currentEvent.currentTab = 5;
              else this.currentEvent.currentTab = 0;

              //get registrants
              this.getRegistrants(this.currentEvent.attendees);
            }
          }
        } else {
          console.log("event data does not exist");
          let event, multiConnectRoute;

          //Check if super user is accesssing the MC event
          if (this.queryPrivilege && this.queryPrivilege == "superUser") {
            //Add a new document to vuex store
            event = new Event({
              id: this.eventId,
            });
            multiConnectRoute = {
              name: "addMultiConnect",
              params: { eventId: this.eventId },
              query: { privilege: "superUser" },
            };
          } else {
            //Add a new document to vuex store
            event = new Event({
              id: this.eventId,
              businessProfileId: this.selectedBusinessProfileId,
              hostName: this.businessProfile.businessName,
              eventCategory: constants.EVENT_CATEGORY.multiConnect,
            });
            multiConnectRoute = {
              name: "addMultiConnect",
              params: { eventId: this.eventId },
            };
          }

          this.setCurrentEvent(event);

          //Generate public link for event
          // this.currentEvent.generatePublicLink();

          //Change route to created mode
          this.isEditMode = false;

          this.$router.push(multiConnectRoute);
        }
      });

    //Get linked sub-events for this parent event
    this.unsubscribeLinkedSubEvents = this.initializeLinkedSubEvents({
      parentEventId: this.eventId,
      businessProfileId: this.userProfile.businessProfileId,
    });

    this.unsubscribeLinkedSessions = this.initializeLinkedSessions({
      parentEventId: this.eventId,
      businessProfileId: this.userProfile.businessProfileId,
    });
  },
  destroyed() {
    this.unsubscribeEventsSnapshot();
    this.clearCurrentEvent();
    this.clearLinkedSubEvents();
    this.clearLinkedSessions();
  },
  data() {
    return {
      tabItems: [
        { title: "Link details", icon: "mdi-calendar-month", id: "0" },
        { title: "Link invitation", icon: "mdi-email-newsletter", id: "1" },
      ],
      showDialog: false,
      isTravelEvent: false,
      tabs: 0,
      nextButtonText: "Next",
      snackbar: false,
      timeout: 2000,
      snackbarText: "",
      //disableSaveButton: true,
      tabs: [
        { index: 0, title: "Event Details" },
        { index: 1, title: "Featured Profiles" },
        { index: 2, title: "Event Program" },
        { index: 3, title: "Event Invitation" },
        //{ index: 4, title: "Event Promotion" }, temporarily removed
      ],
      editEventName: false,
      eventStatus: "",
      snackbarTimeout: 3000,
      updatedEventName: "",
      nameRules: [(v) => !!v || "This is a required field"],
      showShareMultiConnectLinkMenu: false,
      shareMenuTab: 0,
      runInitialSetup: true,
      isEditMode: false,
      currentRoute: "",
      unsubscribeEventsSnapshot: null,
      eventId: "",
      isAwaitingSave: false,
      startNotifications: [],
      endNotifications: [],
      queryPrivilege: "",
      displayImageURLError: false,
      showLoadingDialog: false,
      updateSocialMediaImageLink: false,
      stepper: [],
      validateComponents: [],
      unsubscribeLinkedSubEvents: null,
      unsubscribeLinkedSessions: null,
    };
  },
  watch: {
    "currentEvent.startDateTime": function (newValue) {
      if (newValue) {
        this.calculateNotificationDateTimeForEventStart(newValue);
      }
    },
    expirationDateTime: function (newValue) {
      if (newValue) {
        this.calculateNotificationDateTimeForEventExpiry(newValue);
      }
    },
    $route(newValue) {
      let queryTab = this.$route.query.tab;

      if (queryTab != undefined) this.currentEvent.currentTab = queryTab;

      if (this.currentRoute == "editMultiConnect")
        this.$router.replace({
          name: "editMultiConnect",
          params: { eventId: this.eventId },
        });
      else
        this.$router.replace({
          name: "addMultiConnect",
          params: { eventId: this.eventId },
        });
    },
    "currentEvent.compressedCoverImageURL": function () {
      //Set it to true so that deep link can be regenerated
      this.updateSocialMediaImageLink = true;
    },
    "currentEvent.attendees": function () {
      this.getRegistrants(this.currentEvent.attendees);
    },
  },
  methods: {
    ...mapActions([
      "setCurrentEvent",
      "initializeEvent",
      "updateBusinessProfileDetails",
      "showSnackbar",
      "clearCurrentEvent",
      "getRegistrants",
      "initializeLinkedSubEvents",
      "clearLinkedSubEvents",
      "initializeLinkedSessions",
      "clearLinkedSessions",
    ]),

    async handleNext() {
      this.isAwaitingSave = true;

      if(!this.currentEvent.enableContentFeed) {
        this.currentEvent.sessionPostCreationAccess = "";
      }

      //Regenerate the dynamic link with updated meta images if image was changed
      if (this.updateSocialMediaImageLink)
        await this.currentEvent.generatePublicLink();

      //Trim hostname
      this.currentEvent.hostName = this.currentEvent.hostName.trim();

      //Set createdBy to Pappyon HQ for event created by super user
      if (this.queryPrivilege == "superUser") {
        this.currentEvent.createdBy = "Pappyon HQ";
      } else {
        //Set createdBy to Pappyon HQ for event created by super user
        this.currentEvent.createdBy =
          this.userProfile.firstName + " " + this.userProfile.lastName;
      }

      //Save triggers for start date
      if (this.startNotifications.length > 0)
        await this.currentEvent.saveEventTriggers(
          this.startNotifications,
          "startDateTime"
        );

      //Save triggers for end date
      if (this.endNotifications.length > 0)
        await this.currentEvent.saveEventTriggers(
          this.endNotifications,
          "endDateTime"
        );

      //Save expiration date time
      this.currentEvent.expirationDateTime =
        this.currentEvent.getEventExpirationDateTime();

      if (this.isEditMode) {
        console.log("in edit mode...");
        if (this.validate()) {
          console.log("form is valid");
          //Save event
          this.currentEvent.save();

          this.isAwaitingSave = false;

          this.showSnackbar({ show: true, text: "Saved successfully!" });
        } else {
          console.log("form is invalid");
        }
      } else {
        let isValid = await this.validateComponents[
          this.currentStep - 1
        ].validatePage();

        console.log("this.validateComponents: ", this.validateComponents);
        console.log("isValid: ", isValid);

        if (isValid) {
          if (this.currentStep != this.currentEvent.stepper.length) {
            this.currentEvent.isCreationInProgress = true;

            //Get the next step
            let nextStepItem = this.currentEvent.stepper.find((item) => {
              return item.step == this.currentStep + 1;
            });

            //Update the current step and wizard progress
            this.currentEvent.wizardProgress = nextStepItem.stepName;
            this.currentEvent.currentStep = nextStepItem.stepName;

            this.currentEvent.save();
          } else {
            this.currentEvent.isCreationInProgress = false;

            //Show loading dialog
            this.showLoadingDialog = true;

            //Generate the dynamic link for event
            if (this.currentEvent.linkPrivacy == "Public")
              await this.currentEvent.generatePublicLink();

            //Create a new post object
            let post = new Post({
              multiConnectEventId: this.currentEvent.id,
              type: constants.POST_MULTI_CONNECT_ATTENDED,
              createdOn: new Date(),
            });

            //Generate the document id
            post.generateId();

            //Link the post id to the event
            this.currentEvent.postId = post.id;

            //Save the post and event to firestore
            await this.currentEvent.batchSave(post);

            //Send invitation emails to the sponsor
            //START: COMMENTED FOR SOUTHSTART
            // if (
            //   this.currentEvent.sponsors &&
            //   this.currentEvent.sponsors.length > 0
            // ) {
            //   await Promise.all(
            //     this.currentEvent.sponsors.map(async (sponsor) => {
            //       await sponsor.sendInvitationEmail(
            //         this.currentEvent.id,
            //         this.currentEvent.name,
            //         this.businessProfile.businessName,
            //         "multiConnect"
            //       );

            //       await this.addAttendee(sponsor);
            //     })
            //   );
            // }
            //END: COMMENTED FOR SOUTHSTART

            console.log("last step of create MC event");
            //Hide the loading dialog
            this.showLoadingDialog = false;
            //Show the Mc link dialog
            this.showDialog = true;
            //Send event creation confirmation email to the host
            this.currentEvent.sendEventCreationConfirmationEmail();
          }
        } else {
          console.log("page is invalid");
        }
      }
      this.isAwaitingSave = false;
    },

    validate() {
      if (this.currentEvent.currentTab == 0) {
        return this.$refs.addEditLinkDetails.validate();
      } else if (this.currentEvent.currentTab == 3)
        return this.$refs.eventPromotion.validate();
      else {
        return true;
      }
    },

    formattedDateTime(dateTime) {
      return Utility.formatDateTime(dateTime);
    },

    handleCloseDialog() {
      console.log(
        "this.currentEvent.currentTab: ",
        this.currentEvent.currentTab
      );

      this.showDialog = false;
      let multiConnectRoute = {
        name: "editMultiConnect",
        params: { eventId: this.eventId },
        query: { tab: 2 },
      };
      if (this.queryPrivilege == "superUser") {
        multiConnectRoute.query[`privilege`] = "superUser";
      }
      this.$router.replace(multiConnectRoute);
    },

    handleValidation(isValid) {
      return isValid;
      //this.disableSaveButton = !isValid;
    },

    handleBlur() {
      this.editEventName = false;

      //Hide dashed border from input container
      eventNameContainer.classList.remove("event-container-focused");

      //Update event name
      if (
        this.updatedEventName.length > 0 &&
        this.updatedEventName != this.currentEvent.name
      ) {
        this.currentEvent.name = this.updatedEventName;
        this.currentEvent.save();
      }
    },

    disableTab(tab) {
      if (this.isEditMode) return false;
      else {
        if (tab.index > this.currentEvent.wizardProgress) {
          return true;
        } else {
          return false;
        }
      }
    },
    eventLink(isQrCode) {
      const link = this.$appHostUrl + '/event/' + this.currentEvent.id + `?name=${this.currentEvent.name}`;
      if (isQrCode) {
        const indexOfQuery = link.indexOf('?');
        return link.substring(0, indexOfQuery);
      } else {
        return link;
      }
    },
    async copyToClipboard() {
      const link = this.eventLink(false);
      Utility.copyToClipboard(encodeURI(link));
      this.showSnackbar({ show: true, text: "Copied to clipboard!" });
    },

    shareViaEmail() {
      window.open("mailto:?subject=Share EventConnect Link");
    },

    handleFocus() {
      let eventNameContainer = document.getElementById("eventNameContainer");
      //Show dashed border on input container
      eventNameContainer.classList.add("event-container-focused");
    },

    calculateNotificationDateTimeForEventStart(startDateTime) {
      this.startNotifications = [];
      let now = new Date();

      let timeSlotsInMinutes = [
        {
          message: `${this.currentEvent.name} will start in 48 hours`,
          mins: 2880,
        },
        {
          message: `${this.currentEvent.name} will start soon!`,
          mins: 960,
        },
        {
          message: `${this.currentEvent.name} will start in less than an hour`,
          mins: 60,
        },
      ];

      timeSlotsInMinutes.forEach((time) => {
        let dateTime = new Date(startDateTime.getTime());

        let timeToRun = new Date(
          dateTime.setMinutes(dateTime.getMinutes() - time.mins)
        );
        if (timeToRun > now) {
          this.startNotifications.push(
            new EventTrigger({
              hasRun: false,
              message: time.message,
              multiconnectId: this.currentEvent.id,
              timeToRun: timeToRun,
              type: constants.MULTICONNECT_REMINDER,
              fieldType: "startDateTime",
              timeSlotInMinutes: time.mins,
            })
          );
        }
      });
    },

    calculateNotificationDateTimeForEventExpiry(endDateTime) {
      this.endNotifications = [];

      let now = new Date();

      let timeSlotsInMinutes = [
        // {
        //   message: `${this.currentEvent.name} will expire in 24 hours`,
        //   mins: 1440,
        // },
        // {
        //   message: `${this.currentEvent.name} will expire soon!`,
        //   mins: 960,
        // },
        // {
        //   message: `${this.currentEvent.name} will expire in less than an hour`,
        //   mins: 60,
        // },
        {
          message: `${this.currentEvent.name} has expired`,
          mins: 0,
        },
      ];

      timeSlotsInMinutes.forEach((time) => {
        let dateTime = new Date(endDateTime.getTime());

        let timeToRun = new Date(
          dateTime.setMinutes(dateTime.getMinutes() - time.mins)
        );
        if (timeToRun > now) {
          this.endNotifications.push(
            new EventTrigger({
              hasRun: false,
              message: time.message,
              multiconnectId: this.currentEvent.id,
              timeToRun: timeToRun,
              type: constants.MULTICONNECT_REMINDER,
              fieldType: "endDateTime",
              timeSlotInMinutes: time.mins,
            })
          );
        }
      });

      if (this.currentEvent.endDateTime != null) {
        //Start: Add a trigger doc to send email 2 hours
        let dateTime = new Date(this.currentEvent.endDateTime.getTime());

        let timeToRun = new Date(
          dateTime.setMinutes(dateTime.getMinutes() + 120)
        );

        this.endNotifications.push(
          new EventTrigger({
            hasRun: false,
            message: `${this.currentEvent.name} ended 2 hours ago`,
            multiconnectId: this.currentEvent.id,
            timeToRun: timeToRun,
            type: constants.MULTICONNECT_REMINDER,
            fieldType: "endDateTime",
            timeSlotInMinutes: 120,
          })
        );
      }
    },
    handleExitMultiConnect() {
      if (this.queryPrivilege == "superUser") {
        this.$router.push({ name: "Analytics", query: { tab: 3 } });
      } else {
        this.$router.push({ name: "MultiConnect" });
      }
    },
    async addAttendee(sponsor) {
      if (
        !this.currentEvent.invitees.some(
          (invitee) => invitee.email == sponsor.email
        )
      ) {
        let invitee = new Attendee({
          email: sponsor.email,
          attendeeId: uuid.v4(),
          invitedAt: new Date(),
        });
        this.currentEvent.invitees.unshift(invitee);

        //Save
        this.currentEvent.save();

        invitee.sendInvitation(
          this.currentEvent.linkPrivacy,
          this.currentEvent.dynamicLink,
          this.currentEvent.name,
          this.userProfile.firstName,
          this.userProfile.lastName,
          this.currentEvent.hostName
        );
      }
    },
    handleBack() {
      if (this.currentStep == 1) this.$router.push({ name: "MultiConnect" });
      else {
        let previousStepItem = this.stepper.find((item) => {
          return item.step == this.currentStep - 1;
        });
        this.currentEvent.currentStep = previousStepItem.stepName;
        this.currentEvent.save();
      }
    },
    handleStepClick(step, stepName) {
      let progressStepNumber = this.stepper.find((item) => {
        return item.stepName == this.currentEvent.wizardProgress;
      }).step;
      if (step <= progressStepNumber) this.currentEvent.currentStep = stepName;
    },
    registerValidation(componentType, component) {
      this.validateComponents.push(component);
    },
  },
};
</script>
<style scoped>
.theme--dark.v-list-item--active::before {
  opacity: 0;
}
.v-tab {
  text-transform: capitalize !important;
}

.event-name-container {
  border: 2px dashed transparent;
  min-height: 30px;
}

.event-name-container:hover {
  border: 2px dashed #e5e5e5;
  border-radius: 3px;
}

.event-container-focused {
  border: 2px dashed #e5e5e5;
  border-radius: 3px;
}

/* .theme--dark.v-list-item--active::before {
  opacity: unset !important;
}*/

.event-name-container
  .theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  padding: 0px !important;
}
</style>